import common from '@/locales/en/common';
import components from '@/locales/en/components';

export default {
  ...common,
  ...components,
};
